import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { haveSession, getAccessToken } from "@/usecase/token-operators.usecase";

const http: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_ADAPTER_API_BASE_URL,
  timeout: 20 * 1000,
});

http.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const token = getAccessToken();
    if (haveSession()) {
      config.headers.common["Authorization"] = `Bearer ${token}`;
    }
    // for ie11
    if (config.method === "get") {
      const timestamp: number = new Date().getTime();
      config.params = { ...config.params, timestamp };
    }
    return config;
  },
  (error: any) => {
    return Promise.reject(error?.response?.data?.errors || { message: "connection error", name: "" });
  },
);

export default http;
